export const EVENTS = [
	{
		slug: 'codymelville',
		img: '/img/artists/artist01.png',
		date: 'SAT, 31 JAN · 20:30',
		singer: 'Khruangbin',
		place: 'City Winery',
		distance: '0.2 Miles away',
	},
	{
		slug: 'codymelville',
		img: '/img/artists/artist02.png',
		date: 'Sat, 31 Jan · 19:00',
		singer: 'Ana Popović',
		place: 'City Winery',
		distance: '0.2 Miles away',
	},
	{
		slug: 'codymelville',
		img: '/img/artists/artist03.png',
		date: 'Sat, 31 Jan · 16:30',
		singer: 'Cody Melville',
		place: 'City Winery',
		distance: '0.2 Miles away',
	},
	{
		slug: 'codymelville',
		img: '/img/artists/artist04.png',
		date: 'Sat, 31 Jan · 12:30',
		singer: 'Cody Melville',
		place: 'City Winery',
		distance: '0.2 Miles away',
	},
];
